import axios from "axios";
import Utils from "../utils/utils";

export const FETCH_STUDENT_REQUEST = "FETCH_STUDENT_REQUEST";
export const FETCH_STUDENT_SUCCESS = "FETCH_STUDENT_SUCCESS";
export const FETCH_STUDENT_FAILURE = "FETCH_STUDENT_FAILURE";

const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;

export const fetchStudentRequest = () => ({
  type: FETCH_STUDENT_REQUEST,
});

export const fetchStudentSuccess = (studentData) => ({
  type: FETCH_STUDENT_SUCCESS,
  payload: studentData,
});

export const fetchStudentFailure = (error) => ({
  type: FETCH_STUDENT_FAILURE,
  payload: error,
});

export const fetchStudentData = () => {
  return async (dispatch) => {
    dispatch(fetchStudentRequest());
    const user = Utils.getLoggedInUser();
    const token = Utils.getToken();

    if (!user || !token) {
      dispatch(fetchStudentFailure("User not logged in or token missing."));
      return;
    }

    try {
      const res = await axios.get(`${SERVER_URL}/students/${user.userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const student = res.data;
      dispatch(fetchStudentSuccess(student));
    } catch (error) {
      dispatch(fetchStudentFailure(error.message));
    }
  };
};
